function siteServiceForm() {
  var fieldPhone = $('#site-service-form .field-phone')

  if (fieldPhone.length > 0) {
    fieldPhone.mask('+ZZZ ZZZ ZZ ZZZ', {
      translation: {
        Z: { pattern: /[0-9]/, optional: false }
      },
      selectOnFocus: true,
      reverse: false
    })
    fieldPhone.keydown(function(e) {
      var oldvalue = $(this).val()
      var field = this
      setTimeout(function() {
        if (field.value.indexOf('+370 ') !== 0) {
          $(field).val(oldvalue)
        }
      }, 1)
    })
  }
}

function searchPlaceholder() {
  $('.ipWidget-SiteSearch form :input').each(function(index, elem) {
    var eId = $(elem).attr('id')
    var label = null
    if (
      eId &&
      (label = $(elem)
        .parents('form')
        .find('label[for=' + eId + ']')).length == 1
    ) {
      $(elem).attr(
        'placeholder',
        $(label)
          .html()
          .trim()
      )
      $(label).remove()
    }
  })
}

export { siteServiceForm, searchPlaceholder }
